"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var desktop_table_1 = require("./desktop-table/desktop-table");
var mobile_table_1 = require("./mobile-table/mobile-table");
var table_style_1 = require("./table-style");
function Table(props) {
    var dataRows = props.dataRows, onDragItemEnd = props.onDragItemEnd;
    var _a = (0, react_1.useState)([]), stateItems = _a[0], setStateItems = _a[1];
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        if (!destination) {
            return;
        }
        var newItems = Array.from(stateItems);
        var removed = newItems.splice(source.index, 1)[0];
        newItems.splice(destination.index, 0, removed);
        setStateItems(newItems);
        onDragItemEnd === null || onDragItemEnd === void 0 ? void 0 : onDragItemEnd(result);
    };
    (0, react_1.useEffect)(function () {
        setStateItems(dataRows);
    }, [dataRows]);
    return ((0, jsx_runtime_1.jsxs)(table_style_1.StyledMediaTable, { children: [(0, jsx_runtime_1.jsx)(desktop_table_1.DesktopTable, __assign({}, props, { dataRows: stateItems, onDragItemEnd: onDragEnd })), (0, jsx_runtime_1.jsx)(mobile_table_1.MobileTable, __assign({}, props, { dataRows: stateItems, onDragItemEnd: onDragEnd }))] }));
}
exports.Table = Table;
